var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"mb-4"},[_c('conversion-component',{attrs:{"courses":_vm.courses,"crypto":_vm.cryptos,"balances":_vm.balances,"myMethods":_vm.myMethods},on:{"convert":_vm.convert}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }